/**
 * @file  JavaScript entry point of the project
 */
// import '../assets/scss/responsive-ticketbox.scss'
// import '../assets/scss/shenyun-responsive.scss'
import '../assets/scss/x-mobile-checkout.scss'


import { applyPolyfills } from './base/polyfills.js'
import { initPointerInputEnv } from './utils/pointer-input-env'

import barba from '@barba/core'
import { gsap } from 'gsap'
import '../vendor/time-circles.js'


import { Chart } from './checkout/load-seating-chart'
import { BestAvailable } from './checkout/best-available'
// import { EnterEmail } from './checkout/enter-email.js'
import { ReviewCart } from './checkout/review-cart'
import './checkout/check-out-navigation.js'
import { GiftCard } from './checkout/gift-card.js'
import { FastPayment } from './checkout/fast-payment.js'
import { Confirmation } from './checkout/confirmation.js'
import './checkout/share-seats.js'
import './checkout/exit-survey.js'
import { transitions } from './transitions/transitons.js'
import { ajaxSubmitInvite } from './components/referral.js'
import CookieBannerOption from './components/cookieBanner.js'
import useEmailTemplate from  './components/useEmailTemplate.js'
import { triggerByPcParameter } from './checkout/trigerPromotionChanel.js'


// const { barba, barbaRouter: router } = window
window.barba = barba
// window.router = barbaRouter



/*
 * App Class
 */

class App {
  static start () {
    return new App()
  }

  constructor () {
    Promise
      .all([
        App.domReady()
      ])
      .then(this.init.bind(this))
  }

  static domReady () {
    return new Promise(resolve => {
      document.addEventListener('DOMContentLoaded', resolve)
    })
  }

  static showPage () {
    document.documentElement.classList.add('ready')
  }

  init () {
    // console.info('🚀App:init')
    // Avoid "blank page" on JS error
    try {
      const duration = 10000
			// @ts-ignore
      barba.hooks.before(({ current }) => {
        const openFromVars = {
          opacity: 1
        }
        const openToVars = {
          opacity: 0,
          delay: 0,
          duration: 0.5
        }
        gsap.fromTo(current.container, openFromVars, openToVars)
      })
	    // @ts-ignore
      barba.hooks.after(({ next }) => {
        const closeFromVars = {
          opacity: 0
        }
        const closeToVars = {
          opacity: 1,
          delay: 1,
          duration: 0.75
        }
        gsap.fromTo(next.container, closeFromVars, closeToVars)
        // document.body.classList.remove('PageLoading')
      })
      barba.init({
        debug: true,
        timeout: duration,
        transitions,
        cacheIgnore: true,
        prevent: ({ el }) => el.classList && el.classList.contains('no-barba'),
        views: [Chart, BestAvailable, ReviewCart, GiftCard, FastPayment, Confirmation],
				// @ts-ignore
        requestError: (trigger, action, url, response) => {
          console.info('REQUEST ERROR')
          console.info(url)
          console.info(response)
        }

      })
    } catch (err) {
      console.error(err)
    }
    App.showPage()
  }
}

// $(async () => {
// Wait with further execution until needed polyfills are loaded.
applyPolyfills()
initPointerInputEnv()

App.start()

// console.log('YaY, my first ES6-Module !!!')
// })

// const views = [Chart, BestAvailable, EnterEmail, ReviewCart, GiftCard, FastPayment, Confirmation]
//
// views.forEach((v, i) => {
//   window.v = v
// })
window.Chart = Chart
window.BestAvailable = BestAvailable
// window.EnterEmail = EnterEmail
window.ReviewCart = ReviewCart
window.GiftCard = GiftCard
window.FastPayment = FastPayment
window.Confirmation = Confirmation


const subDomain = window.location.hostname.split('.')[0]
const subDomainLength = subDomain.length
const domainLangCode = subDomain.substring(subDomainLength - 2, subDomainLength)
console.debug(domainLangCode)
const showCookieBannerSiteMap = ['it', 'be', 'uk', 'de', 'cz', 'pl', 'es', 'se', 'dk', 'at', 'nl', 'fr']
if (showCookieBannerSiteMap.includes(domainLangCode) && !window.detectIE()) {
	const cb = new CookieBannerOption()
}

window.triggerByPcParameter = triggerByPcParameter
window.useEmailTemplate = useEmailTemplate
window.ajaxSubmitInvite = ajaxSubmitInvite
